document.addEventListener('DOMContentLoaded', () => {
  const urlParams = new URLSearchParams(window.location.search);
  const sortSelect = document.getElementById('sortSelect');
  const validSortByOptions = new Set([
    'manual',
    'best-selling',
    'title-ascending',
    'title-descending',
    'price-ascending',
    'price-descending',
    'created-ascending',
    'created-descending',
  ]);

  if (!sortSelect) return;

  const currentSort = urlParams.get('sort_by');
  const defaultSort = sortSelect.dataset.defaultSort || 'manual';
  sortSelect.value = validSortByOptions.has(currentSort) ? currentSort : defaultSort;
  sortSelect.addEventListener('change', () => {
    urlParams.set('sort_by', sortSelect.value);
    window.location.search = urlParams.toString();
  });
});
